import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

/**
 * El link corto de campana: `/r/redes` → `/auth/dinamic-signup?origen=redes`.
 *
 * Vive en el mismo front y no en un acortador externo por dos razones: el
 * link muestra el dominio de Aguacate (en redes un bit.ly se lee como spam) y
 * no depende de una cuenta de terceros que alguien tiene que pagar y no
 * perder.
 *
 * Un guard y no un `redirectTo`: el redirect de Angular no pasa un parametro
 * de ruta a un query param. El codigo se reenvia tal cual; el que decide si
 * vale es el backend, con su lista blanca de origenes.
 */
export const linkCampanaGuard: CanActivateFn = (route: ActivatedRouteSnapshot) =>
  inject(Router).createUrlTree(['/auth/dinamic-signup'], {
    queryParams: { origen: route.paramMap.get('codigo') },
  });
